import { toast } from "react-toastify";
import { SuccessToast } from "../components/atom/SucessToast";

export const successToast = (text: string) => {
  toast(SuccessToast, {
    data: {
      text,
    },
    closeButton: false,
    hideProgressBar: true,
    bodyClassName: "p-0",
    className: "!bg-transparent !shadow-none p-0",
  });
};
